import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { CurrencyEur, PencilSimple } from '@phosphor-icons/react';

function intervalLabel(months) {
  if (months === 1) return 'mois';
  if (months === 3) return 'trimestre';
  return 'an';
}

export function AdminPlansTab({ plans, setEditPlan }) {
  return (
    <div className="space-y-3" data-testid="plans-tab">
      {plans.map(plan => (
        <Card key={plan.id} className={`border ${plan.is_active ? '' : 'opacity-50'}`}
          data-testid={`admin-plan-${plan.id}`}>
          <CardContent className="p-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-4 min-w-0">
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${
                plan.popular ? 'bg-[#FF6B00] text-white' : 'bg-gray-100 text-gray-500'
              }`}>
                <CurrencyEur size={22} weight="bold" />
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h4 className="font-bold text-sm">{plan.name}</h4>
                  {plan.popular && <Badge className="bg-[#FF6B00] text-white text-[9px] px-1.5">Populaire</Badge>}
                  {!plan.is_active && <Badge variant="outline" className="text-[9px]">Inactif</Badge>}
                </div>
                <p className="text-sm text-[#FF6B00] font-bold mt-0.5">
                  {plan.price} EUR / {intervalLabel(plan.interval_months)}
                </p>
                <p className="text-[10px] text-[#9CA3AF] mt-0.5">Essai {plan.trial_days} jours - {plan.description}</p>
              </div>
            </div>
            <Button variant="outline" size="sm" onClick={() => setEditPlan({...plan})}
              className="h-10 flex-shrink-0" data-testid={`edit-plan-${plan.id}`}>
              <PencilSimple size={16} className="mr-1" /> Modifiér
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
